import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "leaflet/dist/leaflet.css";
import "./styles.css";

import { App } from "./App";

const raiz = document.getElementById("root");
if (raiz === null) throw new Error("Falta o #root no index.html");

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
